import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../AbstractElements'
import HomeReport from './HomeReport'
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";

export default function ReportList() {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="List Of Biomarkers" parent="Home" title="List Of Biomarkers" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <HomeReport />
                    </Col>
                </Row>
            </Container>

        </Fragment>
    )
}
